import ModelWithFacilityApi from "./ModelWithFacilityApi";

class CogenDemandApi extends ModelWithFacilityApi {
	constructor(token, clientID, onUnauthorized) {
		super(token, clientID, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "co_gen_demand/";
	}

	async copyPreviousDemandWeek(date, facility, onSuccess, onError) {
		this.Post(
			this.baseUrl +
				`copy_latest_week/?date=${date}&facility=${facility.split("/").slice(-2)[0]}`,
			undefined,
			onSuccess,
			onError,
		);
	}
}

export default CogenDemandApi;
